import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import SvgIcon from "../svg-icon";
import {useTranslation} from "react-i18next";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import stringHelper from "../../helpers/string-helper";

const SidebarRaces = props => {

    const {active} = props
    const {i18n, t} = useTranslation()
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const currentLanguage = i18n.language; // Get the current language
    const [searchParams, setSearchParams] = useSearchParams()

    const navigate = useNavigate()
    const [races, setRaces] = useState([])
    const [raffles, setRaffles] = useState([])

    useEffect(() => {
        associateServices.getPromotions({
            language: activeLanguage?.key
        }).then(res => {
            setRaces(res?.data?.races || [])
            setRaffles(res?.data?.raffles || [])
        })
    }, [activeLanguage?.key])

    const handleNavigation = path => navigate(path)


    // if (races?.length <= 0 && raffles?.length <= 0)
    //     return null

    return (
        <div className="sidebar__menu">
                                <span className="sidebar__title">
                                                {t('sidebar.promotions')}
                                </span>
            <ul className="sidebar__nav sidebar__nav--border">

                <li className={active === 'promotions' ? 'active' : ''}>
                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/promotions')}>
                        <SvgIcon id={'gift'}/>
                        {t('promotions.title')}
                    </Link>
                </li>

                <li className={active === 'tournaments' ? 'active' : ''}>
                    <Link to={stringHelper.getLocalizedPath(currentLanguage, '/tournaments')}>
                        <SvgIcon id={'tournaments'}/>
                        {t('tournaments.title')}
                    </Link>
                </li>


                {
                    races?.map(race => (
                        <li key={race.id}>
                            <Link

                                to={stringHelper.getModalPathRace('race', race.uuid, searchParams)}
                            >
                                <SvgIcon id={'75'}/>
                                {race?.title}
                            </Link>
                        </li>
                    ))
                }

                {
                    raffles?.map(raffle => (
                        <li key={raffle.id}>
                            <Link
                                to={stringHelper.getModalPathRace('raffle', raffle.uuid, searchParams)}
                            >
                                <SvgIcon id={'100'}/>
                                {/*{t(`promotions.${raffle.key}`)}*/}

                                {raffle?.title}

                            </Link>
                        </li>
                    ))
                }

            </ul>
        </div>
    )

}

export default SidebarRaces
